import React, { FC } from "react";

import { HexColor } from "@mapmycustomers/shared/types/AnyColor";

import styles from "./ColorBar.module.scss";

export interface ColorBarProps {
  colorFn: (index: number) => HexColor;
  count: number;
  flip?: boolean;
}

const ColorBar: FC<ColorBarProps> = ({ colorFn, count, flip }) => {
  return (
    <div className={styles.container}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} style={{ backgroundColor: colorFn(flip ? count - index - 1 : index) }} />
      ))}
    </div>
  );
};

export default ColorBar;
